import React, { useState, useEffect } from "react";
import api from "api/api";
import { useNavigate } from "react-router-dom";

// mui component
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import Slide from "@mui/material/Slide";
import DialogContentText from "@mui/material/DialogContentText";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

// icon
import CloseIcon from "@mui/icons-material/Close";

//Props Validations
import PropTypes from "prop-types";

// reduc
import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

const Transition = React.forwardRef(function Transition(props, ref) {
    return (
        <Slide
            direction="up"
            ref={ref}
            {...props}
        />
    );
});

const IOSSwitch = styled((props) => (
    <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 32,
    height: 18,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(14px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#005EEF",
                opacity: 1,
                border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "#33cf4d",
            border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 14,
        height: 14,
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === "light" ? "grey" : "#005EEF",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));

function UserRoleUpdateComponent({ title = "", type = "", selectedRows = [], isOpen = false, setIsUpdateDialogOpen = () => {}, rolesData = [], fetchData = () => {} }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userAdmin = useSelector((state) => state.userStore.userAdmin) || false;

    // add dialog confirmation
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

    const [data, setData] = useState({
        name: "",
        email: "",
        roleData: [],
    });

    const setUpdatedData = () => {
        if (type === "update") {
            let email = selectedRows.email;
            let namePart = email.split("@");
            let finalName = titleCase(namePart[0].replaceAll(".", " "));
            setData({
                name: finalName,
                email: email,
                roleData: selectedRows.user_product_categroy_role,
            });
        }
    };

    useEffect(() => {
        if (userAdmin !== true || !userAdmin) {
            navigate("/");
        }
    }, [userAdmin]);

    useEffect(() => {
        if (type === "update") {
            setUpdatedData();
        }
    }, [type]);

    const handleSave = () => {
        const finalData = data.roleData.map((datum) => {
            return {
                id: datum.id,
                product_category: datum.product_category,
                role: rolesData.find((role) => role.title.toLowerCase() === datum.role__title.toLowerCase()).id,
            };
        });
        let payload = {
            user_product_categroy_role: finalData,
        };
        try {
            const url = process.env.REACT_APP_SERVER_PATH + `/user-product-category-roles/user-admin-access-management-update/`;
            api.put(url, payload)
                .then(() => {
                    fetchData();
                    handleClose();
                    handleConfirmationDialogClose();
                })
                .catch((error) => {
                    handleError("error", error);
                    handleConfirmationDialogClose();
                });
        } catch (error) {
            handleError("error", error);
            handleConfirmationDialogClose();
        }
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const titleCase = (str) => {
        let splitStr = str.toLowerCase().split(" ");
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
    };

    const handleClose = () => {
        setIsUpdateDialogOpen(false);
    };

    const handleRoleToggleChange = (checked, i) => {
        const val = checked ? "admin" : "user";
        const updatedRoles = data.roleData.map((datum) => {
            if (i === datum.id) {
                return { ...datum, role__title: val };
            } else {
                return datum;
            }
        });
        setData({
            ...data,
            ["roleData"]: updatedRoles,
        });
    };

    const handleConfirmationDialogClose = () => {
        setIsConfirmationDialogOpen(false);
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 14,
                        fontWeight: "700",
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                    // className="liner-light-blue-background-2"
                    id="customized-dialog-title"
                >
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 2,
                        color: "rgb(51, 94, 234) !important",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div className="row pb-2">
                        <div className="col-3">
                            <label
                                htmlFor="name-input"
                                className="input-label vertical-center text-sm "
                            >
                                Name :
                            </label>
                        </div>
                        <div className="col-9">
                            <input
                                type="text"
                                id="name-input"
                                value={data.name}
                                className="input-label-field text-sm disabled-input"
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-3">
                            <label
                                htmlFor="email-input"
                                className="input-label vertical-center text-sm "
                            >
                                Email :
                            </label>
                        </div>
                        <div className="col-9">
                            <input
                                type="text"
                                id="email-input"
                                value={data.email}
                                className="input-label-field text-sm disabled-input"
                                disabled={true}
                            />
                        </div>
                    </div>
                    {data.roleData.map((datum) => (
                        <div
                            className="row pb-2"
                            key={datum.id}
                        >
                            <div className="col-6">
                                <label className="input-label vertical-center text-sm">
                                    {datum.product_category__title} / {datum.business_group__title} :
                                </label>
                            </div>
                            <div className="col-4">
                                <span className={datum.role__title.toLowerCase() === "user" ? "color-blue text-bold-6 text-sm" : "text-sm"}>User</span>
                                <IOSSwitch
                                    sx={{ m: 1 }}
                                    checked={datum.role__title.toLowerCase() === "admin"}
                                    onChange={(e) => handleRoleToggleChange(e.target.checked, datum.id)}
                                />
                                <span className={datum.role__title.toLowerCase() === "admin" ? "color-blue text-bold-6 text-sm" : "text-sm"}>Admin</span>
                            </div>
                        </div>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button
                        className="custom-btn"
                        variant="outlined"
                        size="small"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="custom-btn liner-light-blue-background me-3"
                        size="small"
                        autoFocus
                        variant="contained"
                        color="primary"
                        onClick={() => setIsConfirmationDialogOpen(true)}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            {isConfirmationDialogOpen && (
                <Dialog
                    open={isConfirmationDialogOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    // onClose={handleArchiveClickClose}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle className="text-base">Confirm updating this role</DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            className="text-sm"
                            id="alert-dialog-slide-description"
                        >
                            Are you sure you want to update the role?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            className="me-2 custom-btn"
                            size="small"
                            variant="contained"
                            color="error"
                            onClick={handleConfirmationDialogClose}
                        >
                            Disagree
                        </Button>
                        <Button
                            className="me-2 custom-btn liner-light-blue-background"
                            size="small"
                            variant="contained"
                            onClick={handleSave}
                        >
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

// Typechecking props
UserRoleUpdateComponent.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    selectedRows: PropTypes.array,
    isOpen: PropTypes.bool,
    setIsUpdateDialogOpen: PropTypes.func,
    rolesData: PropTypes.array,
    fetchData: PropTypes.func,
};

export default UserRoleUpdateComponent;
